import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import PropTypes from 'prop-types';
import React from 'react';
import { get } from 'lodash';
import EditModal from '../../common/modal/EditModal';
import RowDisplay from '../../common/RowDisplay';
import enums from '../../../constants/enums';
import findEnumDisplayName from '../../../constants/findEnumDisplayName';
import SexualOrientationForm from './SexualOrientationForm';
function SexualOrientationDisplay(props) {
  var _context;
  var contact = props.contact;
  var sexualityEnums = get(enums, 'people.sexual_orientations', []);
  var editSection = /*#__PURE__*/React.createElement(EditModal, {
    header: "Edit Sexual Orientation",
    size: "normal",
    formName: "edit-sexual-orientation",
    editButtonId: "edit-sexual-orientation-btn",
    id: "edit-sexual-orientation-modal"
  }, /*#__PURE__*/React.createElement(SexualOrientationForm, {
    contact: contact,
    sexualOrientationsEnums: sexualityEnums
  }));
  return /*#__PURE__*/React.createElement(RowDisplay, {
    editSection: editSection,
    label: "Sexual Orientation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement("p", {
    "data-test-element": "sexuality-display",
    className: "profile-value"
  }, contact.sexuality && contact.sexuality.length ? _mapInstanceProperty(_context = contact.sexuality).call(_context, function (orientation) {
    return findEnumDisplayName(sexualityEnums, orientation);
  }).join(', ') : '--')), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement("p", {
    "data-test-element": "sexuality-other-display",
    className: "profile-value"
  }, contact.sexuality_other ? contact.sexuality_other : '--')));
}
SexualOrientationDisplay.propTypes = {
  contact: PropTypes.object.isRequired
};
export default SexualOrientationDisplay;
//# sourceMappingURL=SexualOrientationDisplay.js.map